import React,{ Suspense, useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import AOS from 'aos/dist/aos';
import 'aos/dist/aos.css';
import Home from './componets/Home';
import Spinner from './Spinner';

const MedicineTracker = React.lazy(() => import('./componets/projects/Final_projects/MedicineTracker'));
const Wego = React.lazy(() => import('./componets/projects/Final_projects/Wego.js'));
const DisplyProjects = React.lazy(() => import('./componets/projects/Final_projects/DisplayProjects.js'));
const ScheduleApp = React.lazy(()=> import('./componets/projects/Final_projects/ScheduleApp.js'));
const NoMatch = React.lazy(() => import('./componets/NoMatch'));


function App() {
  const [loader,setLoader] = useState(false);
  AOS.init({
    duration: 800,
    ease: "ease-out-back",
    offset: 300,
    once: true,
    delay:200,
  });
  AOS.refresh();

  useEffect(() => {
    setLoader(true);
    setTimeout( () => {
      setLoader(false);
    },3000);
  }, []);
  return (
    <>
    {
      loader ?
        <Spinner/>
      :
      <Routes>
        <Route path="/" element={
          <Suspense fallback={<Spinner/>}>
            <Home/>
          </Suspense>} />
          <Route index element={
            <Suspense fallback={<Spinner/>}>
              <Home />
            </Suspense>} />
            <Route path="teams" element={
              <Suspense fallback={<Spinner />}>
                <DisplyProjects />
              </Suspense>} />
              <Route path="schedule" element={
                <Suspense fallback={<Spinner/>}>
                  <ScheduleApp />
                </Suspense>} />
              <Route path="wego" element={
                <Suspense fallback={<Spinner/>}>
                  <Wego />
                </Suspense>} />
              <Route path="medicine" element={
                <Suspense fallback={<Spinner/>}>
                  <MedicineTracker />
                </Suspense>} />
              <Route path="*" element={
                <Suspense fallback={<Spinner/>}>
                  <NoMatch />
                </Suspense>}
            />
      </Routes>
    }
    </>
  );
}
export default App;